export default __webpack_public_path__ + "images/logo-tracer.svg?9ca9b196d240b95381dfe7e29909746d";